import React, { useEffect, useRef, useState } from "react";

import { Box } from "@chakra-ui/react";
import { displayEmoji, getEmojiReactionList } from '../helpers/dsr-helpers';
import LaunchdeckSpinner from '../../global/components/helper-components/components/LaunchdeckSpinner';


export default function EmojiMenu({ messageIndex, postReactions, handleAddRemoveMessageReaction, setShowEmojiMenu, postId }) {

  const reactionsRef = useRef(postReactions)
  const [loadingState, setLoadingState] = useState(null)

  const emojiList = getEmojiReactionList();
  function handleChooseEmoji(reactionProps) {
    handleAddRemoveMessageReaction(reactionProps)
    setLoadingState(true)
  }

  useEffect(() => {
    if (postReactions !== reactionsRef.current) {
      reactionsRef.current = postReactions
      setLoadingState(false)
      setShowEmojiMenu(false)
    }
  }, [postReactions])


  if (loadingState) {
    return (
      <Box py='0.2em'>
        <LaunchdeckSpinner thickness='2px' boxSize='1em' />
      </Box>
    )
  }

  return (
    <React.Fragment>

      {emojiList.map((emojiName, emojiIndex) => {
        const relevantReaction = postReactions.find(reaction => reaction.reactionType === emojiName);
        const { reactionCount } = relevantReaction || {};

        // Only display the emoji if it hasnt been used before 
        if (!relevantReaction || reactionCount === 0) {

          const reactionProps = {
            ...relevantReaction,
            postId,
            reactionType: emojiName,
            userMadeThisReaction: false //First time adding this reaction, value is false by default
          }

          return (
            <React.Fragment key={'reaction_' + emojiIndex + '_' + messageIndex}>
              <Box cursor='pointer' px='0.5em' fontSize='1em' onClick={() => handleChooseEmoji(reactionProps)}>  {displayEmoji(emojiName)} </Box>
            </React.Fragment>
          )
        } else return null;
      })}

    </React.Fragment>
  );

}
